import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { Table as PrimeDataTable } from 'primeng/table';
import { ActivatedRoute } from '@angular/router';
import { AffCodeMassAddComponent } from 'src/app/affcode/affcode-mass-add/affcode-mass-add.component';
import { MassCommParamNav } from 'src/app/communication/shared/mass-comm-param-nav.model';
import { EventRead } from '../shared/event-read.model';
import { AssignAttendeeTable } from 'src/app/events/attendee/shared/assign-attendee-table.model';
import { AttendedFlagOrUnflag } from 'src/app/events/attendee/shared/attended-flag-or-unflag.model';
import { AttendeeMin } from 'src/app/events/attendee/shared/attendee-min.model';
import { AttendeeSearchParams } from 'src/app/events/attendee/shared/attendee-search-params.model';
import { AttendeeSearchResult } from 'src/app/events/attendee/shared/attendee-search-result.model';
import { UpdateAttendeeCustomFields } from 'src/app/events/attendee/shared/update-attendee-custom-fields.model';
import {
  WlEventsV4ToolbarBroadcastService,
  WlEventsV4ToolbarEventTypeEnum,
} from 'src/app/shared/container/toolbars/module/events-v4/broadcast';
import { MassCommParameterService } from 'src/app/communication/shared/mass-comm-parameter.service';
import { UtilService, DialogService, NotificationService, TranslationService, DatagridService, NameValue } from 'src/app/shared';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { EventItemSummary } from '../shared/items/event-item-summary.model';
import { EventV4AttendeeService } from '../shared/attendee/event-v4-attendee.service';
import { EventsV4Service } from '../shared/events-v4.service';
import { EventV4ItemService } from '../shared/items/event-v4-item.service';
import { CheckboxChangeEvent } from 'primeng/checkbox';

@Component({
  selector: 'wl-event-v4-attendee-management',
  templateUrl: './event-v4-attendee-management.component.html',
  styleUrl: './event-v4-attendee-management.component.css',
    standalone: false
})
export class EventV4AttendeeManagementComponent implements OnInit {
  @Input() public event: EventRead;
  @ViewChild('massAddAffCode', { static: false }) massAddAffCode: AffCodeMassAddComponent;
  @ViewChild('attendeeDataGrid', { static: true }) public _attendeeDataGrid: PrimeDataTable;

  public _selectedAttendeeHeaderIds: Array<number>;
  public _unselectedAttendeeHeaderIds: Array<number>;
  public _selectAllAttendees: boolean;
  public attendeeSearchResult: AttendeeSearchResult;
  public unfilteredAttendeeSearchResult: AttendeeSearchResult = new AttendeeSearchResult();
  public initialLoadComplete: boolean;
  public searchParams: AttendeeSearchParams;
  public eventId: number;
  public showDetails: boolean;
  public showAdvancedSearch: boolean;
  public eventItems: Array<EventItemSummary>;
  public sortByFields: Array<NameValue>;
  public isSearching: boolean;
  public selectedAction: number;
  public actions: Array<NameValue>;
  public executing: boolean;
  public pageSizeOptions: Array<NameValue>;
  public pageSizeSelection: number;
  public pageSize: number;
  public tableName: string;
  public custom2: string;
  public custom3: string;
  public custom4: string;
  public custom5: string;
  public flagOrUnflagAsAttended: boolean;
  public showModal = false;

  public constructor(
    private _route: ActivatedRoute,
    private _utilService: UtilService,
    private _eventsService: EventsV4Service,
    private _eventAttendeeService: EventV4AttendeeService,
    private _eventItemService: EventV4ItemService,
    private _translationService: TranslationService,
    private _dialogService: DialogService,
    private _dataGridService: DatagridService,
    private _notifyService: NotificationService,
    private _eventsToolbarBroadcastService: WlEventsV4ToolbarBroadcastService,
    private _navigationService: NavigationService,
    private _massCommParameterService: MassCommParameterService
  ) {
    this._selectedAttendeeHeaderIds = new Array<number>();
    this._unselectedAttendeeHeaderIds = new Array<number>();
    this._selectAllAttendees = false;

    this.event = new EventRead();
    this.initialLoadComplete = false;
    this.attendeeSearchResult = new AttendeeSearchResult();
    this.searchParams = new AttendeeSearchParams();
    this.searchParams.OrderBy = 'SignUpDate:desc';
    this.searchParams.PageSize = 20;

    this.eventId = 0;
    this.showDetails = false;
    this.showAdvancedSearch = false;
    this.eventItems = new Array<EventItemSummary>();
    this.sortByFields = new Array<NameValue>();
    this.isSearching = false;
    this.selectedAction = 0;
    this.actions = new Array<NameValue>();
    this.pageSizeOptions = new Array<NameValue>();
    this.executing = false;

    this.flagOrUnflagAsAttended = false;
    this.pageSizeSelection = 1;
    this.pageSize = 20;
  }

  ngOnInit() {
    this._route.params.subscribe((params: any) => {
      if (this._utilService.isNotNullOrUndefined(params['id'])) {
        this.eventId = Number(params['id']);
        this.searchParams.EventId = this.eventId;

        this._attendeeDataGrid.reset();

        this._eventItemService.getEventItems(this.eventId).then((data: Array<any>) => {
          for (let item of data) {
            item.Selected = false;
          }

          this.eventItems = data;
        });
      }
    });

    // setup sort by dropdown
    let nv1 = new NameValue();
    let nv2 = new NameValue();
    let nv3 = new NameValue();
    let nv4 = new NameValue();
    let nv5 = new NameValue();
    let nv6 = new NameValue();
    let nv7 = new NameValue();
    let nv8 = new NameValue();
    let nv9 = new NameValue();
    let nv10 = new NameValue();
    let nv11 = new NameValue();
    let nv12 = new NameValue();

    nv1.name = 'Sign Up Date (desc)';
    nv1.value = 'SignUpDate:desc';
    nv2.name = 'Sign Up Date (asc)';
    nv2.value = 'SignUpDate:asc';

    nv3.name = 'Org Name (asc)';
    nv3.value = 'OrgName:asc';
    nv4.name = 'Org Name (desc)';
    nv4.value = 'OrgName:desc';

    nv5.name = 'First Name (asc)';
    nv5.value = 'FirstName:asc';
    nv6.name = 'First Name (desc)';
    nv6.value = 'FirstName:desc';

    nv7.name = 'Last Name (asc)';
    nv7.value = 'LastName:asc';
    nv8.name = 'Last Name (desc)';
    nv8.value = 'LastName:desc';

    nv9.name = 'Amount Due (asc)';
    nv9.value = 'AmountDue:asc';
    nv10.name = 'Amount Due (desc)';
    nv10.value = 'AmountDue:desc';

    //RegistrationOrgName
    nv11.name = 'Registration Org Name (asc)';
    nv11.value = 'RegistrationOrgName:asc';
    nv12.name = 'Registration Org Name (desc)';
    nv12.value = 'RegistrationOrgName:desc';

    this.sortByFields.push(nv1);
    this.sortByFields.push(nv2);
    this.sortByFields.push(nv3);
    this.sortByFields.push(nv4);
    this.sortByFields.push(nv5);
    this.sortByFields.push(nv6);
    this.sortByFields.push(nv7);
    this.sortByFields.push(nv8);
    this.sortByFields.push(nv9);
    this.sortByFields.push(nv10);
    this.sortByFields.push(nv11);
    this.sortByFields.push(nv12);

    // Assign the actions and page size options as new arrays once their translations resolve.
    // p-select only re-reads [options] when the array reference changes, so pushing into the
    // bound array leaves the selected label stuck on the placeholder.
    this._buildTranslatedOptions([
      ['events.registration.management.actions.select-action', 0],
      ['events.attendees.management.actions.export-attendees', 1],
      ['events.attendees.management.actions.flag-selected-as-attended', 2],
      ['events.attendees.management.actions.flag-selected-as-not-attended', 3],
      ['events.attendees.management.actions.print-name-badges', 4],
      ['events.registration.management.actions.add-selected-profiles-to-affiliation', 5],
      ['events.attendees.management.actions.email-these-attendees', 6],
      ['events.attendees.management.actions.export-attendees-extended', 7],
      ['events.attendees.management.actions.export-attendees-extended-excel', 10],
      ['events.attendees.management.actions.export-selected-attendees-extended', 8],
      ['events.attendees.management.actions.assign-table-selected-attendees', 9],
      ['events.attendees.management.actions.update-custom-fields-selected-attendees', 11],
    ]).then((options: Array<NameValue>) => (this.actions = options));

    this._buildTranslatedOptions([
      ['events.attendees.management.show-20-option', 1],
      ['events.attendees.management.show-100-option', 2],
      ['events.attendees.management.show-all-option', 3],
    ]).then((options: Array<NameValue>) => (this.pageSizeOptions = options));
  }

  private _buildTranslatedOptions(keyValues: Array<[string, number]>): Promise<Array<NameValue>> {
    return Promise.all(keyValues.map(([key]) => this._translationService.getTitlecase(key))).then((labels: string[]) =>
      keyValues.map(([, value], index) => new NameValue(labels[index], value))
    );
  }

  public handleAttendeeGridPageSizeChange = (data: string): void => {
    this.pageSizeSelection = parseInt(data);
    var pageNum = 0;

    switch (this.pageSizeSelection) {
      case 1:
        this.pageSize = 20;
        pageNum = 1;
        break;
      case 2:
        this.pageSize = 100;
        pageNum = 1;
        break;
      case 3:
        this.pageSize = 0;
        pageNum = 0;
        break;
      default:
        break;
    }

    this.searchParams.PageSize = this.pageSize;
    this.searchParams.PageNumber = pageNum;
    // forces the grid's paginator to update it's numbers
    this.attendeeSearchResult.TotalCount = 0;
    this.getAttendees();
  };

  public lazyLoadAttendees = ($event: any): void => {
    this._dataGridService.mapDatagridPagingToPagedSearch($event, this.searchParams);

    // override grid request and get all attendees
    if (this.pageSize == 0) {
      this.searchParams.PageNumber = 0;
      this.searchParams.PageSize = 0;
    }

    if (this.isSearching == false) {
      this.getAttendees();
    }
  };

  public getAttendees = (): void => {
    this.searchParams.EventItemIds = new Array<number>();
    for (let item of <any>this.eventItems) {
      if (item.Selected == true) {
        this.searchParams.EventItemIds.push(item.EventItemId);
      }
    }

    if (this.searchParams.EventId > 0) {
      this.isSearching = true;
      this._eventAttendeeService.searchAttendees(this.searchParams).then(
        (data: AttendeeSearchResult) => {
          if (data.PageSize == 0) {
            this.pageSize = data.TotalCount;
          }
          this._dataGridService.mapPagedResultsToPagedSearch(data, this.searchParams);

          this.attendeeSearchResult = data;

          for (let attendee of this.attendeeSearchResult.Result) {
            if (this._selectAllAttendees == true) {
              attendee.Selected = !this._utilService.arrayContainsValue(this._unselectedAttendeeHeaderIds, attendee.AttendeeId);
            } else {
              attendee.Selected = this._utilService.arrayContainsValue(this._selectedAttendeeHeaderIds, attendee.AttendeeId);
            }
          }
          if (!this.initialLoadComplete) {
            this.unfilteredAttendeeSearchResult = data;
          }
          this.initialLoadComplete = true;
          this.isSearching = false;
        },
        () => {
          this.isSearching = false;
        }
      );
    }
  };

  /**
   * starts the search over at page 1
   */
  public search() {
    this.searchParams.PageNumber = 1;
    this.startSearch();
  }

  public startSearch(): void {
    this._attendeeDataGrid.reset();
  }

  public editAttendee = (attendee: AttendeeMin): void => {
    this._eventsToolbarBroadcastService.broadcast({
      type: WlEventsV4ToolbarEventTypeEnum.editAttendee,
      data: { EventId: this.event.EventId, RegistrationId: Number(attendee.RegistrationId), AttendeeId: attendee.AttendeeId },
    });
  };

  public toggleAdvancedSearch(): void {
    if (this.showAdvancedSearch) this.closeAdvancedSearch();
    else this.openAdvancedSearch();
  }

  public openAdvancedSearch = (): void => {
    this.showAdvancedSearch = true;
  };

  public closeAdvancedSearch = (): void => {
    this.showAdvancedSearch = false;
  };

  public deleteAttendee = (): void => {};

  public actionChanged = (data: string): void => {
    this.selectedAction = parseInt(data);
  };

  public executeAction = (): void => {
    this.addActionSearchParams();
    this.executing = true;
    switch (this.selectedAction) {
      case 0:
        //for test get selected attendees to run action against
        let message =
          'Include Attendees:  ' +
          this.searchParams.AttendeeIds.toString() +
          ' -- ' +
          'Exclude Attendees:  ' +
          this.searchParams.ExcludedAttendeeIds.toString();

        this._dialogService.info(message);
        this.executing = false;
        break;
      case 1:
        this.executing = true;
        this._eventAttendeeService.exportAttendees(this.eventId).then(
          (data: string) => {
            this._navigationService.popupSafeNavigate(data);
            this.executing = false;
          },
          () => {
            this.executing = false;
          }
        );
        break;
      case 2:
        ////flag as attended
        this.selectAllEventItems();
        this.flagOrUnflagAsAttended = true;
        this.showModal = true;
        break;

      case 3:
        /////flag as not attended
        this.selectAllEventItems();
        this.flagOrUnflagAsAttended = false;
        this.showModal = true;
        break;

      case 4:
        this._eventsService.getNameBadgeReportUrl(this.eventId).then((url) => this._navigationService.popupSafeNavigate(url));
        this.executing = false;
        break;

      case 5:
        this.getAllSelectedAttendeeIds().then(
          (data: Array<number>) => {
            let attendeeHeaderIds = data;
            this._eventAttendeeService.getProfileIdsForAttendeeHeaderIds(attendeeHeaderIds).then(
              (data: Array<number>) => {
                let profileIds = data;
                this.massAddAffCode.setProfileIds(profileIds);
                this.massAddAffCode.addAffCodes();
                this.executing = false;
              },
              () => {
                this.executing = false;
              }
            );
          },
          () => {
            this.executing = false;
          }
        );

        break;

      case 6:
        this.getAllSelectedAttendeeIds().then(
          (data: Array<number>) => {
            let attendeeHeaderIds = data;
            let search = new AttendeeSearchParams();
            search.EventId = this.eventId;
            search.AttendeeIds = attendeeHeaderIds;
            search.PageSize = 99999999;
            this._eventAttendeeService.searchAttendees(search).then(
              (data: AttendeeSearchResult) => {
                let emailProfileIds = new Array<number>();
                let emailManuals = new Array<NameValue>();
                for (let attendee of data.Result) {
                  if (attendee.ProfileId > 0) {
                    emailProfileIds.push(attendee.ProfileId);
                  } else {
                    if (this._utilService.isNotNullEmptyOrWhitespace(attendee.Email)) {
                      let displayName = '';
                      if (this._utilService.isNotNullEmptyOrWhitespace(attendee.NameForBadge)) {
                        displayName = attendee.NameForBadge;
                      } else if (this._utilService.isNotNullEmptyOrWhitespace((attendee.FName + ' ' + attendee.LName).trim())) {
                        displayName = attendee.FName + ' ' + attendee.LName.trim();
                      } else {
                        displayName = attendee.OrgName;
                      }
                      let nv = new NameValue(displayName, attendee.Email);
                      emailManuals.push(nv);
                    }
                  }
                }

                this._massCommParameterService.setEventId(this.eventId);
                this._massCommParameterService.setFromType('attendees');
                this._massCommParameterService.setEmailParams(emailManuals);
                this._massCommParameterService.setProfileIdParams(emailProfileIds);
                let navFrom = new MassCommParamNav();
                navFrom.DisplayText = this._translationService.getInstantCapitalizeFirstCharacter('events.labels.back-to-event');
                navFrom.NavigatedFromRoute = '/manage-event/' + this.eventId.toString() + '/attendees';
                this._massCommParameterService.setNavigatedFromParams(navFrom);
                this._navigationService.navigateToCommunicationNewEmailMessage();
              },
              () => {
                this.executing = false;
              }
            );
          },
          () => {
            this.executing = false;
          }
        );

        break;

      case 7:
        this.executing = true;
        this._eventAttendeeService.exportAttendeesExtended(this.eventId).then(
          (data: string) => {
            this._navigationService.popupSafeNavigate(data);
            this.executing = false;
          },
          () => {
            this.executing = false;
          }
        );
        break;

      case 10:
        this.executing = true;
        this._eventAttendeeService.exportAttendeesExtendedAsExcel(this.eventId).then(
          (data: string) => {
            this._navigationService.popupSafeNavigate(data);
            this.executing = false;
          },
          () => {
            this.executing = false;
          }
        );
        break;

      case 8:
        this.executing = true;
        this.getAllSelectedAttendeeIds().then((data: Array<number>) => {
          let attendeeHeaderIds = data;

          this._eventAttendeeService.exportAttendeesExtendedAndFiltered(this.eventId, attendeeHeaderIds).then(
            (data: string) => {
              this._navigationService.popupSafeNavigate(data);
              this.executing = false;
            },
            () => {
              this.executing = false;
            }
          );
        });

        break;
      case 9:
        this.executing = true;
        this.getAllSelectedAttendeeIds().then((data: Array<number>) => {
          let attendeeHeaderIds = data;

          let assignAttendeeTable: AssignAttendeeTable = new AssignAttendeeTable();
          assignAttendeeTable.AttendeeHeaderIds = attendeeHeaderIds;
          assignAttendeeTable.TableName = this.tableName;
          this._eventAttendeeService.assignAttendeesToTable(assignAttendeeTable).then(
            () => {
              this.executing = false;

              let message: string = this._translationService.getInstant('events.attendees.management.actions.assign-table-success');
              this._notifyService.success(message);
            },
            () => {
              this.executing = false;

              let message: string = this._translationService.getInstant('events.attendees.management.actions.assign-table-error');
              this._dialogService.error(message);
            }
          );
        });
        break;
      case 11:
        this.executing = true;
        this.getAllSelectedAttendeeIds().then((data: Array<number>) => {
          let attendeeHeaderIds = data;

          let updateAttendeeCustomFields: UpdateAttendeeCustomFields = new UpdateAttendeeCustomFields();
          updateAttendeeCustomFields.AttendeeHeaderIds = attendeeHeaderIds;
          updateAttendeeCustomFields.Custom2 = this.custom2;
          updateAttendeeCustomFields.Custom3 = this.custom3;
          updateAttendeeCustomFields.Custom4 = this.custom4;
          updateAttendeeCustomFields.Custom5 = this.custom5;
          this._eventAttendeeService.updateAttendeesCustomFields(updateAttendeeCustomFields).then(
            () => {
              this.executing = false;

              let message: string = this._translationService.getInstant('events.attendees.management.actions.update-custom-fields-success');
              this._notifyService.success(message);
            },
            () => {
              this.executing = false;

              let message: string = this._translationService.getInstant('events.attendees.management.actions.update-custom-fields-error');
              this._dialogService.error(message);
            }
          );
        });
        break;
      default:
        break;
    }

    this.clearActionSearchParams();
  };

  public selectAll = ($event: CheckboxChangeEvent): void => {
    this._selectAllAttendees = $event.checked;

    //reset the tracking arrays
    this._selectedAttendeeHeaderIds = new Array<number>();
    this._unselectedAttendeeHeaderIds = new Array<number>();

    for (let attendee of this.attendeeSearchResult.Result) {
      attendee.Selected = $event.checked;
    }
  };

  public selectOrUnselectAttendee = (attendee: AttendeeMin): void => {
    if (attendee.Selected == true) {
      this._selectedAttendeeHeaderIds.push(attendee.AttendeeId);
      this._utilService.arrayRemoveEntry(this._unselectedAttendeeHeaderIds, attendee.AttendeeId);
    } else {
      this._unselectedAttendeeHeaderIds.push(attendee.AttendeeId);
      this._utilService.arrayRemoveEntry(this._selectedAttendeeHeaderIds, attendee.AttendeeId);
    }
  };

  public getAllSelectedAttendeeIds = (): Promise<Array<number>> => {
    if (this._selectAllAttendees == true) {
      let searchParams: AttendeeSearchParams = <AttendeeSearchParams>JSON.parse(JSON.stringify(this.searchParams));
      searchParams.PageNumber = 0;
      searchParams.PageSize = 0;
      searchParams.OrderBy = '';

      return this._eventAttendeeService.getAttendeeHeaderIdsForEvent(this.eventId, searchParams).then((attendeeIds: Array<number>) => {
        if (!this._unselectedAttendeeHeaderIds) return attendeeIds;

        if (attendeeIds) return attendeeIds.filter((x) => this._unselectedAttendeeHeaderIds.indexOf(x) < 0);
        return [];
      });
    } else {
      return Promise.resolve(this._selectedAttendeeHeaderIds);
    }
  };

  public addActionSearchParams = (): void => {
    //get any selected attendees
    this.searchParams.PageNumber = 1;
    this.searchParams.PageSize = 99999;

    if (this._selectAllAttendees == true) {
      this.searchParams.AttendeeIds = new Array<number>();
      this.searchParams.ExcludedAttendeeIds = this._unselectedAttendeeHeaderIds;
    } else {
      this.searchParams.AttendeeIds = this._selectedAttendeeHeaderIds;
      this.searchParams.ExcludedAttendeeIds = new Array<number>();
    }
  };

  public clearActionSearchParams = (): void => {
    this._dataGridService.mapPagedResultsToPagedSearch(this.attendeeSearchResult, this.searchParams);

    this.searchParams.AttendeeIds = new Array<number>();
    this.searchParams.ExcludedAttendeeIds = new Array<number>();
  };

  /**
   * sets all the search and advanced search fields to default
   */
  public resetSearchForm() {
    this.searchParams.Keyword = '';
    this.searchParams.SearchAnySignUpDate = true;
    this.searchParams.SignUpStartDate = new Date();
    this.searchParams.SignUpEndDate = new Date();
    this.searchParams.AllUnpaid = false;
    this.searchParams.AllWithBlankAttendees = false;
    this.searchParams.AllWithProfileIdNotAssigned = false;

    if (this.eventItems) this.eventItems.forEach((x) => ((<any>x).Selected = false));
  }

  /**
   * resets the form and starts a fresh search
   */
  public resetAndSearch() {
    this.resetSearchForm();
    this.startSearch();
  }

  /**
   * triggered when a registration is saved
   */
  public handleRegistrationSaved() {
    this.getAttendees();
  }

  public selectAllEventItems() {
    for (let eventItem of this.eventItems) {
      eventItem.Selected = true;
    }
  }

  public flagOrUnflagAttendeesForSelectedEventItems(): void {
    this.showModal = false;
    this.executing = true;

    this.getAllSelectedAttendeeIds()
      .then((data: Array<number>) => {
        let dto: AttendedFlagOrUnflag = new AttendedFlagOrUnflag();
        let selectedEventItems: Array<number> = this.eventItems
          .filter((eventItem) => eventItem.Selected)
          .map((eventItem) => eventItem.EventItemId);

        dto.Attended = this.flagOrUnflagAsAttended;
        dto.AttendeeHeaderIds = data;
        dto.EventItemIds = selectedEventItems;

        return this._eventAttendeeService.updateAttendedFlagForEventItemsByEvent(this.eventId, dto);
      })
      .then(() => {
        return this.getAttendees();
      })
      .catch((err) => {
        this._notifyService.httpError(err);
      })
      .finally(() => {
        this.executing = false;
      });
  }

  public cancelSelectedEventItems = (): void => {
    this.executing = false;
    this.showModal = false;
  };

  /**
   * calls the attendee search with no filter to get total attendees for event
   */
  public updateAttendeeTotals(): void {
    let params = new AttendeeSearchParams();
    params.PageNumber = 1;
    params.PageSize = 1;
    params.EventId = this.eventId;

    this._eventAttendeeService.searchAttendees(params).then((results) => (this.unfilteredAttendeeSearchResult = results));
  }

  /**
   * triggered by clicking "# with no profile id)
   */
  public handleAttendeesWithNoProfileIdClick(): void {
    this.searchParams.AllWithProfileIdNotAssigned = true;
    this.openAdvancedSearch();
    this.search();
  }

  /**
   * triggered by checking/unchecking the attended checkbox
   */
  public handleAttendeeAttendedCheckChanged(attendee: AttendeeMin): void {
    var attendeeAny: any = <any>attendee;

    if (attendeeAny._updatingAttendedFlag) return;

    attendeeAny._updatingAttendedFlag = true;
    let newAttendedValue = attendee.Attended;

    this._eventAttendeeService.updateAttendedFlag([attendee.AttendeeId], newAttendedValue).then(
      () => (attendeeAny._updatingAttendedFlag = false),
      () => {
        // failed, switch it back
        attendee.Attended = !newAttendedValue;
        attendeeAny._updatingAttendedFlag = false;
      }
    );
  }
}
